import { render, staticRenderFns } from "./DomainOptions.vue?vue&type=template&id=7deaa91e&"
import script from "./DomainOptions.vue?vue&type=script&lang=js&"
export * from "./DomainOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports